/* eslint-disable */
export const categories = [
  {
    id: '9a67dff7-3c38-4052-a335-0cef93438ff6',
    title: 'Hiring',
    slug: 'hiring',
  },
  {
    id: 'a89672f5-e00d-4be4-9194-cb9d29f82165',
    title: 'Marketing',
    slug: 'marketing',
  },
  {
    id: '02f42092-bb23-4552-9ddb-cfdcc235d48f',
    title: 'Convention',
    slug: 'convention',
  },
  {
    id: '5648a630-979f-4403-8c41-fc9790dea8cd',
    title: 'BYT',
    slug: 'byt',
  },
];
export const courses = [
  {
    id: '694e4e5f-f25f-470b-bd0e-26b1d4f64028',
    title: 'Build Your Team',
    slug: 'build-your-team',
    description: 'The purpose of this seminar is to teach you how to use Performia tools for hiring.',
    category: 'byt',
    duration: 30,
    totalSteps: 11,
    updatedAt: 'Jun 28, 2021',
    featured: true,
    progress: {
      currentStep: 3,
      currentStepType: 'READ_TEXT',
      completed: 2,
    },
  },
  {
    id: 'f924007a-2ee9-470b-a316-8d21ed78277f',
    title: 'Convention 2022',
    slug: 'convention-2022',
    description: 'CONVENTION 2022 - PRESENTATIONS - LECTURES - BRIEFINGS - EVALUATIONS - AWARDS',
    category: 'convention',
    duration: 60,
    totalSteps: 11,
    updatedAt: 'Nov 01, 2021',
    featured: true,
    progress: {
      currentStep: 5,
      currentStepType: 'READ_TEXT',
      completed: 3,
    },
  },
  {
    id: '0c06e980-abb5-4ba7-ab65-99a228cab36b',
    title: 'QUAL - MARKETING',
    slug: 'qual-marketing',
    description: 'Set of webinars on Marketing',
    category: 'marketing',
    duration: 120,
    totalSteps: 11,
    updatedAt: 'May 08, 2021',
    featured: false,
    progress: {
      currentStep: 10,
      currentStepType: 'READ_TEXT',
      completed: 1,
    },
  },
  {
    id: '1b9a9acc-9a36-403e-a1e7-b11780179e38',
    title: 'LAS NUEVAS TECNICAS DE RECLUTAMIENTO DE PERSONAL PRODUCTIVO',
    slug: 'las-nuevas-tecnicas-de-drclutamiento-de-personal-productivo',
    description: 'LAS NUEVAS TECNICAS DE RECLUTAMIENTO DE PERSONAL PRODUCTIVO',
    category: 'hiring',
    duration: 30,
    totalSteps: 11,
    updatedAt: 'Jan 09, 2021',
    featured: false,
    progress: {
      currentStep: 4,
      currentStepType: 'READ_TEXT',
      completed: 3,
    },
  },
  {
    id: '55eb415f-3f4e-4853-a22b-f0ae91331169',
    title: 'HOW TO SPOT PRODUCTIVE PEOPLE',
    slug: 'how-to-spot-productive-people',
    description: 'Learn how to spot productive people',
    category: 'byt',
    duration: 45,
    totalSteps: 11,
    updatedAt: 'Jan 14, 2021',
    featured: false,
    progress: {
      currentStep: 6,
      currentStepType: 'READ_TEXT',
      completed: 0,
    },
  },
  {
    id: 'fad2ab23-1011-4028-9a54-e52179ac4a50',
    title: 'Basics of Building A Productive Team',
    slug: 'basics-of-building-a-productive-team',
    description: 'get an insight of the Build Your Team training',
    category: 'byt',
    duration: 90,
    totalSteps: 11,
    updatedAt: 'Jun 24, 2021',
    featured: false,
    progress: {
      currentStep: 6,
      currentStepType: 'READ_TEXT',
      completed: 0,
    },
  },
];
export const demoCourseContent = `
<p class="lead">
    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aperiam lab et fugiat id magnam minus nemo quam
    voluptatem. Culpa deleniti explica nisi quod soluta.
</p>
<p>
    Alias animi labque, deserunt distinctio eum excepturi fuga iure labore magni molestias mollitia natus, officia pofro
    quis sunt temporibus veritatis voluptatem, voluptatum. Aut blanditiis esse et illum maxim, obcaecati possimus
    voluptate! Accusamus <em>adipisci</em> amet aperiam, assumenda consequuntur fugiat inventore iusto magnam molestias
    natus necessitatibus, nulla pariatur.
</p>
<p>
    Amet distinctio enim itaque minima minus nesciunt recusandae soluta voluptatibus:
</p>
<blockquote>
    <p>
        Ad aliquid amet asperiores lab distinctio doloremque <code>eaque</code>, exercitationem explicabo, minus mollitia
        natus necessitatibus odio omnis pofro rem.
    </p>
</blockquote>
<p>
    Assumenda, eum, minima! Autem consectetur fugiat iste sit! Nobis omnis quo repellendus.
</p>
`;
export const demoCourseSteps = [
  {
    order: 0,
    type: 'COURSE_START',
    title: 'Basic Information',
    subtitle: 'Basic Information',
    content: `<h2 class="text-2xl sm:text-3xl">Basic Information</h1> ${demoCourseContent}`,
  },
  {
    order: 1,
    type: 'READ_TEXT',
    title: 'INTRODUCTION, 4 FACTORS',
    subtitle: 'INTRODUCTION, 4 FACTORS',
    content: `<h2 class="text-2xl sm:text-3xl">INTRODUCTION, 4 FACTORS</h1> ${demoCourseContent}`,
  },
  {
    order: 2,
    type: 'READ_PDF',
    title: 'OUTFLOW/ INFLOW, PRODUCTIVITY, GAUSS CURVE',
    subtitle: 'OUTFLOW/ INFLOW, PRODUCTIVITY, GAUSS CURVE',
    content: `<h2 class="text-2xl sm:text-3xl">OUTFLOW/ INFLOW, PRODUCTIVITY, GAUSS CURVE</h1> ${demoCourseContent}`,
  },
  {
    order: 3,
    type: 'WATCH_VIDEO',
    title: 'BE-DO-HAVE, ADs, PRODUCTION CHECK',
    subtitle: 'BE-DO-HAVE, ADs, PRODUCTION CHECK',
    content: `<h2 class="text-2xl sm:text-3xl">BE-DO-HAVE, ADs, PRODUCTION CHECK</h1> ${demoCourseContent}`,
  },
  {
    order: 4,
    type: 'WRITE_ESSAY',
    title: 'PRODUCTION CHECK PART 1',
    subtitle: 'PRODUCTION CHECK PART 1',
    content: `<h2 class="text-2xl sm:text-3xl">PRODUCTION CHECK PART 1</h1> ${demoCourseContent}`,
  },
  {
    order: 5,
    type: 'DO_QUIZ',
    title: 'PERSONALITY',
    subtitle: 'PERSONALITY',
    content: `<h2 class="text-2xl sm:text-3xl">PERSONALITY</h1> ${demoCourseContent}`,
  },

  {
    order: 6,
    type: 'DO_TWINNING_DRILL',
    title: 'PRODUCTION CHECK PART 2',
    subtitle: 'PRODUCTION CHECK PART 2',
    content: `<h2 class="text-2xl sm:text-3xl">PRODUCTION CHECK PART 2</h1> ${demoCourseContent}`,
  },
  {
    order: 7,
    type: 'VIDEO_SUPERVISOR',
    title: 'THEORY - DRILL - PERFORMANCE CHECK TO FIND THE PERFORMER AND DOER',
    subtitle: 'THEORY - DRILL - PERFORMANCE CHECK TO FIND THE PERFORMER AND DOER',
    content: `<h2 class="text-2xl sm:text-3xl">THEORY - DRILL - PERFORMANCE CHECK TO FIND THE PERFORMER AND DOER</h1> ${demoCourseContent}`,
  },
  {
    order: 8,
    type: 'DO_QUIZ',
    title: 'PERSONALITY',
    subtitle: 'PERSONALITY',
    content: `<h2 class="text-2xl sm:text-3xl">PERSONALITY</h1> ${demoCourseContent}`,
  },
  {
    order: 9,
    type: 'WATCH_VIDEO',
    title: 'A TRAIT',
    subtitle: 'A TRAIT',
    content: `<h2 class="text-2xl sm:text-3xl">A TRAIT</h1> ${demoCourseContent}`,
  },
  {
    order: 10,
    type: 'DO_CLAY',
    title: 'B TRAIT',
    subtitle: 'B TRAIT',
    content: `<h2 class="text-2xl sm:text-3xl">B TRAIT</h1> ${demoCourseContent}`,
  },
  {
    order: 11,
    type: 'CLEAR_WORDLIST',
    title: 'B TRAIT',
    subtitle: 'B TRAIT',
    content: `<h2 class="text-2xl sm:text-3xl">B TRAIT</h1> ${demoCourseContent}`,
  },
  {
    order: 12,
    type: 'DO_QUIZ',
    title: 'PERSONALITY',
    subtitle: 'PERSONALITY',
    content: `<h2 class="text-2xl sm:text-3xl">PERSONALITY</h1> ${demoCourseContent}`,
  },
  {
    order: 13,
    type: 'READ_POLICY',
    title: 'B TRAIT',
    subtitle: 'B TRAIT',
    content: `<h2 class="text-2xl sm:text-3xl">B TRAIT</h1> ${demoCourseContent}`,
  },
  {
    order: 14,
    type: 'DO_FINAL_TEST',
    title: 'D TRAIT',
    subtitle: 'D TRAIT',
    content: `<h2 class="text-2xl sm:text-3xl">D TRAIT</h1> ${demoCourseContent}`,
  },
  {
    order: 15,
    type: 'COURSE_COMPLETION',
    title: 'B TRAIT',
    subtitle: 'B TRAIT',
    content: `<h2 class="text-2xl sm:text-3xl">B TRAIT</h1> ${demoCourseContent}`,
  },
];
